import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { GSDevTools } from 'gsap/GSDevTools';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(
  ScrollTrigger,
  SplitText,
  CustomEase,
  // GSDevTools is only registered in development — the import is tree-shaken
  // in production builds so it never adds weight to the production bundle.
  ...(import.meta.dev ? [GSDevTools] : []),
);

// Named ease vocabulary — available globally across all GSAP animations.
// entry:   organic arrival — gentle start, confident deceleration (replaces power3.out)
// exit:    decisive departure — steep acceleration, no linger (replaces power2.in)
// wordPop: 27.5% overshoot on y-axis — words pop into place rather than slide
CustomEase.create('entry', 'M0,0 C0.22,1 0.36,1 1,1');
CustomEase.create('exit', 'M0,0 C0.55,0 0.8,0.45 1,1');
CustomEase.create('wordPop', 'M0,0 C0.175,0.885 0.32,1.275 1,1');

export default defineNuxtPlugin(() => {
  return {
    provide: {
      gsap,
      ScrollTrigger,
      SplitText,
      ...(import.meta.dev ? { GSDevTools } : {}),
    },
  };
});

declare module '#app' {
  interface NuxtApp {
    $gsap: typeof gsap;
    $ScrollTrigger: typeof ScrollTrigger;
    $SplitText: typeof SplitText;
    $GSDevTools?: typeof GSDevTools;
  }
}
